module.exports = {"id":"208364","name":"Clinton Mata","rating":"72","photo":"./data/images/photos/3/208364.png","club":{"name":"KRC Genk","logo":"./data/images/clubs/KRCGenk.png"},"positions":["DD","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ClintonMata0.json
// module id = 843
// module chunks = 0